import Logo from "./Logo";
import Page from "./Page";
import "./Home.css";


const styleHome = {
   boxSizing: "border-box",
};
const styleLogo = {
   fontSize: "28pt",
};
const styleBlurb = {
   fontSize: "16pt",
   whiteSpace: "normal",
   maxWidth: 512, // HARD-CODED in conjunction with Services.css
   textShadow: "0 0 0",
   fontFamily: '"Open Sans", "lucida grande", "Segoe UI", arial, verdana, "lucida sans unicode", tahoma, sans-serif', // HARD-CODED in conjunction index.css
};


export default class Home extends Page {
   render() {
      return (
         <div className="centered" style={styleHome}>
            <Logo style={styleLogo} />
            <p style={styleBlurb}>
               Validating the Cosmos Hub since block <a href="https://github.com/cosmos/mainnet/blob/master/genesis/genesis.cosmoshub-1.json#L18001" target="_blank">1<img className="link" src="/link.svg" alt="external link"/></a>.
            </p>
            <p style={styleBlurb}>
               <span role="img" aria-label="100%">💯</span> Never Slashed. <span role="img" aria-label="secure">🛡</span>
            </p>
            <p style={styleBlurb}>
               Trusted by the
               {" "}<a href="https://cosmoshub-1.bigdipper.live/validator/cosmosvaloper1rcp29q3hpd246n6qak7jluqep4v006cdsc2kkl/delegations" target="_blank">Interchain Foundation (ICF)<img className="link" src="/link.svg" alt="Interchain Foundation (ICF) Initial Delegation"/></a>
               {" "} and <a href="https://commonwealth.im/stride/discussion/13084-redelegate-the-stride-osmosis-validator-set?tab=0" target="_blank">Stride Community<img className="link" src="/link.svg" alt="Stride Osmosis Validator Set"/></a>
               {" "}<a href="https://medium.com/the-interchain-foundation/icf-delegations-program-meet-the-validators-cycle-1-dc586cb2f96" target="_blank">again<img className="link" src="/link.svg" alt="Interchain Foundation (ICF) Cycle 1 Cosmos Hub Delegations"/></a> and
               {" "}<a href="https://drive.google.com/file/d/1aiXLjn-ient8Zw0aIawqLcnLVL6JvzrC/view" target="_blank">again<img className="link" src="/link.svg" alt="Interchain Foundation (ICF) Cycle 2 Cosmos Hub Delegations"/></a>
               {" "} after rigorous objective and subjective scrutiny.
            </p>
            <p>&nbsp;</p>
            <p style={styleBlurb}>
               Tap the icons below to automagically compound your rewards for free on
            </p>
            <p style={styleBlurb}>
               <div className="Restake">
                  <a id="CosmosHubValidator" href="https://restake.app/cosmoshub/cosmosvaloper1rcp29q3hpd246n6qak7jluqep4v006cdsc2kkl" target="_blank"><img src="/atom.svg" alt="Cosmos Hub Validator"/></a>
               </div>
            </p>
            <p style={styleBlurb}>
               or stake with <a href="https://trustwallet.com/" target="_blank">Trust Wallet<img className="link" src="/link.svg"  alt="external link" /></a>.
            </p>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/Home.js